@use '@lib/assets/styles/main.scss' as *;

.offlineLabel {
  margin-top: 8px;
}

.modalContentClassName {
  padding-top: 0;
}
